<template>
  <nav class="navbar col p-0 mov mov1 d-block d-md-none">
    <nav class="navbar segundo d-block">
      <ul class="navbar-nav pr-0">
        <li
          class="col text-center py-5 px-3 bg-menu-azul1"
          @click="show = !show"
        >
          <div class="dropdown" :class="show ? 'show' : ''">
            <div class="text-uppercase p-0" id="dropdownMenu11">
              Admisión
              <br />Técnico Profesional
            </div>
            <div class="dropdown-menu" :class="show ? 'show' : ''">
              <div class="dropdown-item" type="button">
                <router-link :to="{ name: 'AdmisionTP' }">Admisión</router-link>
              </div>
              <div class="dropdown-item" type="button">
                <router-link :to="{ name: 'FCU' }">FCU</router-link>
              </div>
              <div @click="irInstituciones" class="dropdown-item" type="button">
                Instituciones TP
              </div>
              <div @click="irCarreras" class="dropdown-item" type="button">
                Carreras
              </div>
              <div @click="irComparadorITP" class="dropdown-item" type="button">
                Comparador
              </div>
              <div @click="irReglamento" class="dropdown-item" type="button">
                Normativa
              </div>
              <div @click="irCalendario" class="dropdown-item" type="button">
                Calendario
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </nav>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "TecnicoProfesional",
  data() {
    return {
      show: false
    };
  },
  methods: {
    ...mapActions(["setBusqueda"]),
    irReglamento() {
      this.$router.push({ name: "ReglamentoTP" });
    },
    irCalendario() {
      this.$router.push({ name: "CalendarioTP" });
    },
    irInstituciones() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorIP" });
    },
    irCarreras() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorTP" });
    },
    irComparadorITP() {
      this.$router.push({ name: "ComparadorITP" });
    },
    limpiarBusquedasAplicadas() {
      this.setBusqueda([]);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/generales/menuMovil/TecnicoProfesional.vue